import { ProfilesState } from './profiles.state';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxsModule } from '@ngxs/store';

@NgModule({
    declarations: [],
    imports: [CommonModule, NgxsModule.forFeature([ProfilesState])],
})
export class ProfilesStoreModule {}
